import { useStaggeredAnimation, useParallax } from '@/hooks/useScrollAnimation';

const steps = [
  {
    number: '01',
    title: 'Agenda tu consulta',
    desc: 'Contáctanos por teléfono, WhatsApp o visítanos. Te ayudamos a coordinar fecha y especialidad.',
    icon: 'ri-calendar-check-line',
  },
  {
    number: '02',
    title: 'Consulta médica',
    desc: 'Te atienden especialistas calificados. Recibes un diagnóstico preciso y un plan personalizado.',
    icon: 'ri-stethoscope-line',
  },
  {
    number: '03',
    title: 'Comienza tu tratamiento',
    desc: 'Inicia tu recuperación con seguimiento continuo de nuestro equipo médico y de enfermería.',
    icon: 'ri-heart-pulse-line',
  },
];

export default function StepsSection() {
  const { ref, isVisible, getDelay } = useStaggeredAnimation();
  const glow = useParallax(0.14);

  return (
    <section className="relative py-20 md:py-28 px-4 md:px-8 lg:px-12 bg-secondary-950 overflow-hidden">
      <div className="absolute inset-0 texture-dots-light opacity-30" />
      <div
        ref={glow.ref}
        className="absolute -top-20 right-10 w-80 h-80 rounded-full bg-primary-600/25 blur-3xl"
        style={{ transform: `translateY(${glow.offset}px)` }}
      />
      <div className="absolute bottom-0 left-0 w-72 h-72 rounded-full bg-accent-500/15 blur-3xl" />

      <div className="relative max-w-7xl mx-auto" ref={ref}>
        {/* Header */}
        <div className="max-w-2xl mb-14 md:mb-20">
          <span className={`inline-flex items-center gap-2 text-xs font-bold tracking-[0.2em] text-accent-500 uppercase mb-4 reveal ${isVisible ? 'is-in' : ''}`}>
            <span className="w-8 h-px bg-accent-500" />
            Cómo Funciona
          </span>
          <h2 className={`font-heading text-3xl md:text-4xl lg:text-5xl font-medium text-background-50 leading-[1.08] reveal ${isVisible ? 'is-in' : ''}`}>
            Tu camino hacia una mejor <span className="italic text-accent-500">salud</span>
          </h2>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {steps.map((step, i) => (
            <div
              key={step.number}
              className={`relative reveal ${isVisible ? 'is-in' : ''} ${i === 1 ? 'md:mt-10' : ''} ${i === 2 ? 'md:mt-20' : ''}`}
              style={{ transitionDelay: getDelay(i) }}
            >
              <div className="relative rounded-3xl bg-background-50/[0.04] border border-background-50/10 p-7 md:p-8 backdrop-blur-sm hover:bg-background-50/[0.07] transition-colors duration-500 h-full">
                <span className="absolute top-5 right-6 font-heading text-6xl md:text-7xl font-bold text-background-50/[0.07] select-none leading-none">
                  {step.number}
                </span>
                <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-primary-500 text-background-50 mb-6 relative z-10">
                  <i className={`${step.icon} text-2xl`} />
                </div>
                <h3 className="font-heading text-xl md:text-2xl font-semibold text-background-50 mb-3 relative z-10">
                  {step.title}
                </h3>
                <p className="text-sm text-background-300 leading-relaxed relative z-10">
                  {step.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}